import React from 'react';
import { Typography } from '@mui/material';
import theme from 'theme';
import { FRContentDescriptionProps } from './FRContentDescription.props';

const FRContentDescription = ({ children }: FRContentDescriptionProps) => (
  <Typography
    style={{
      fontWeight: 400,
      fontSize: '0.875rem',
      color: theme.palette.black,
      minHeight: '2.5rem',
    }}
    gutterBottom>
    {children}
  </Typography>
);

export default FRContentDescription;
